import { AppConfigProvider, useAppConfig } from './appConfig.tsx';

export { AppConfigProvider, useAppConfig };
